import setThemeForKey from '../actions/setThemeForKey';
import setThemeLoadStatus from '../actions/setThemeLoadStatus';
import ThemeLoadStatus from '../store/schema/ThemeLoadStatus';
import store from '../store/Store';
import { trace } from 'owa-trace';
import Theme from '../store/schema/Theme';

export default async function downloadThemeDefinitions(
    downloadThemeCallback: (colorScheme: string) => Promise<{ [index: string]: Theme }>,
    colorScheme: string = 'default'
) {
    if (!downloadThemeCallback) {
        trace.info('No download theme callback provided');
        setThemeLoadStatus(ThemeLoadStatus.LoadFailed);
    } else if (store.themeStore.loadStatus === ThemeLoadStatus.Unloaded) {
        setThemeLoadStatus(ThemeLoadStatus.Loading);

        try {
            const themes = await downloadThemeCallback(colorScheme);
            Object.keys(themes).forEach((key: string) => {
                setThemeForKey(key, themes[key]);
            });
            setThemeLoadStatus(ThemeLoadStatus.LoadSucceeded);
        } catch (error) {
            trace.info('Error downloading theme definitions: ' + error);
            setThemeLoadStatus(ThemeLoadStatus.LoadFailed);
        }
    }
}
